import { render, staticRenderFns } from "./certiticateChangeLogForm.vue?vue&type=template&id=b21a65a0&"
import script from "./certiticateChangeLogForm.vue?vue&type=script&lang=js&"
export * from "./certiticateChangeLogForm.vue?vue&type=script&lang=js&"
import style0 from "./certiticateChangeLogForm.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports